export default () => ({
  value: '',
  inputChange: function (event) {
    if (event.key === 'Backspace') {
      if (this.value.length > 0) {
        this.value = '';
        return;
      } else {
        const previousElement = event.target.previousElementSibling;
        if (previousElement) {
          previousElement.focus();
          return;
        }
      }
      return;
    }
    const isNumber = isFinite(event.key);
    if (isNumber) {
      this.value = event.key;
      const nextElement = event.target.nextElementSibling;
      if (nextElement) {
        nextElement.focus();
        return;
      }
      return;
    }
    event.stopPropagation();
    event.preventDefault();
  },
  inputPreChange: function (event) {
    const isBackspace = event.key === 'Backspace';
    const isNumber = isFinite(event.key);
    if (
      isNumber === false ||
      event.target.value.length > 0 ||
      isBackspace === false
    ) {
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  },
});
